import _extends from "@babel/runtime/helpers/extends";
import { createTheme } from '@uiw/codemirror-themes';
export var defaultSettingsConsoleLight = {
  background: '#fff',
  foreground: '#000',
  caret: '#000',
  selection: '#c2d2ff',
  selectionMatch: '#b1c1ef',
  gutterBackground: '#fff',
  gutterForeground: '#ada9a9',
  gutterActiveForeground: '#000',
  lineHighlight: '#c7c5c575'
};
export var consoleLightInit = options => {
  var {
    theme = 'light',
    settings = {},
    styles = []
  } = options || {};
  return createTheme({
    theme: theme,
    settings: _extends({}, defaultSettingsConsoleLight, settings),
    styles: [...styles]
  });
};
export var consoleLight = consoleLightInit();